const initState = {
  myFollowedUser: {
    list: [],
    pageSize: 20,
    total: 0,
    page: 1,
    pages: 1,
  },
  myFollowedTopic: {
    list: [],
    pageSize: 20,
    total: 0,
    page: 1,
    pages: 1,
  },
}

const state = Object.assign({}, initState)

export {
  initState,
  state
}